import React, { Component } from 'react';
import LabelWithText from '../../../components/molecules/LabelWithText';
import Label from '../../../components/atoms/Label';
import dateFormatIndo from '../../../utils/helpers/dateFormatIndo';

export default ({ title, dataDetail, setFromParam }) => {
  let col = { label : 'col-md-3', text : 'col-md-9' }
  // console.log('====================================');
  // console.log({ dataDetail });
  // console.log('====================================');
  return(
    <div>
      <div className='container-title'>
        <Label value={`${title} PIC`} className='label-menu'/>
      </div>
      <div>
        <LabelWithText label = {'Nama'} text = {dataDetail.fullName ? dataDetail.fullName : "-"} col={col} />
        <LabelWithText label = {'No. Ponsel'} text = {dataDetail.phone ? dataDetail.phone : "-"} col={col} />
        <LabelWithText label = {'Surel'} text = {dataDetail.email ? dataDetail.email : "-"} col={col} />
        <LabelWithText label = {'Jabatan'} text = {dataDetail.jobPosition ? dataDetail.jobPosition : "-"} col={col} />
        <LabelWithText label = {'Jenis Kelamin'} text = {dataDetail.gender ? setFromParam("gender",dataDetail.gender) : "-"} col={col} />
        <LabelWithText label = {'Kota Tempat Lahir'} text = {dataDetail.birthPlace ? dataDetail.birthPlace : "-"} col={col} />
        <LabelWithText label = {'Tgl. Lahir'} text = {dataDetail.birthDate ? dateFormatIndo(dataDetail.birthDate, 'long') : "-"} col={col} />
        <LabelWithText label = {'Alamat'} text = {dataDetail.address ? dataDetail.address : "-"} col={col} />
        <LabelWithText label = {'Provinsi'} text = {dataDetail.province ? dataDetail.province : "-"} col={col} />
        <LabelWithText label = {'Kota/ Kabupaten'} text = {dataDetail.city ? dataDetail.city : "-"} col={col} />
        <LabelWithText label = {'Kecamatan'} text = {dataDetail.subdistrict ? dataDetail.subdistrict : "-"} col={col} />
        <LabelWithText label = {'Kelurahan'} text = {dataDetail.addressKel ? dataDetail.addressKel : "-"} col={col} />
        <LabelWithText label = {'Kode Pos'} text = {dataDetail.postalCode ? dataDetail.postalCode : "-"} col={col} />
        <LabelWithText label = {'Negara'} text = {dataDetail.country ? dataDetail.country : "-"} col={col} />
        <LabelWithText label = {'Kewarganegaraan'} text = {dataDetail.nationality ? dataDetail.nationality : "-"} col={col} />
        <LabelWithText label = {'No. KTP'} text = {dataDetail.identificationNumber ? dataDetail.identificationNumber : "-"} col={col} />
      </div>
    </div>
  )
}